import * as signalR from '@microsoft/signalr';
import apiRequestHeaders from '../apiRequestHeaders';

export interface Dac7ProgressUpdate {
  reportId: string;
  phase: string;
  currentItem: number;
  totalItems: number;
  message: string;
}

export interface Dac7CompletionUpdate {
  reportId: string;
  success: boolean;
  message: string;
  sellersCreated: number;
  propertiesCreated: number;
  matchedRows: number;
  failedRows: number;
}

class SignalRDac7Service {
  public connection: signalR.HubConnection;

  // eslint-disable-next-line class-methods-use-this
  public onProgressUpdate: (update: Dac7ProgressUpdate) => void = () => {};

  // eslint-disable-next-line class-methods-use-this
  public onCompletionUpdate: (update: Dac7CompletionUpdate) => void = () => {};

  constructor() {
    console.log('SignalR DAC7 Service Created');
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl('/signalr-hubs/dac7-hub', {
        headers: apiRequestHeaders.csrfHeader(),
      })
      .configureLogging(signalR.LogLevel.Error)
      .withAutomaticReconnect()
      .build();

    this.connection.on(
      'ReceiveDac7ProgressUpdate',
      (
        reportId: string,
        phase: string,
        currentItem: number,
        totalItems: number,
        message: string,
      ) => {
        this.onProgressUpdate({
          reportId,
          phase,
          currentItem,
          totalItems,
          message,
        });
      },
    );

    this.connection.on(
      'ReceiveDac7ProcessingComplete',
      (
        reportId: string,
        success: boolean,
        message: string,
        sellersCreated: number,
        propertiesCreated: number,
        matchedRows: number,
        failedRows: number,
      ) => {
        this.onCompletionUpdate({
          reportId,
          success,
          message,
          sellersCreated,
          propertiesCreated,
          matchedRows,
          failedRows,
        });
      },
    );
  }

  public startConnection = async () => {
    try {
      await this.connection.start();
      console.log('SignalR DAC7 Connected.');
    } catch (err) {
      console.error('SignalR DAC7 Connection Error: ', err);
    }
  };

  public stopConnection = async () => {
    try {
      await this.connection.stop();
      console.log('SignalR DAC7 Disconnected.');
    } catch (err) {
      console.error('SignalR DAC7 Disconnection Error: ', err);
    }
  };
}

export default new SignalRDac7Service();
